import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import StepItem from './StepItem'
import { Row, Col } from 'flexbox'

const containerStyle = {
  margin: 0,
  marginBottom: '1.5rem',
  width: '100%'
}

class PageIndicator extends PureComponent {
  static propTypes = {
    colSize: PropTypes.number,
    currentPage: PropTypes.number.isRequired
  }

  static defaultProps = {
    colSize: 1
  }

  render() {
    const { children, colSize, currentPage, style, mobileColSize } = this.props
    return (
      <Row style={{ ...containerStyle, ...style }}>
        {React.Children.map(children, (c, index) => {
          return (
            <Col
              key={index}
              xs={mobileColSize ? mobileColSize : colSize}
              md={colSize}
            >
              <StepItem completed={currentPage > index} number={index + 1}>
                {c}
              </StepItem>
            </Col>
          )
        })}
      </Row>
    )
  }
}

export default PageIndicator
